import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

const PinLocation = lazy(() => import('src/views/PinLocation'));
const LocationLayout = lazy(() => import('src/components/location/LocationLayout'));

const locationRoutes = () => (
    <>
        <Route path="location" element={<LocationLayout navbarColor='white' />}>
            <Route path="pin" element={<PinLocation />} />
            <Route path="" element={<Navigate to="pin" />} />
            <Route path="*" element={<Navigate to="/errors/404" />} />
        </Route>
    </>
)

export default locationRoutes;
